module.exports = __webpack_public_path__ + "static/img/边框5.ef40dae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框5.svg
// module id = v0u7
// module chunks = 2